// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"b864de63","137":"9339355e","541":"35f4fa73","596":"f1d3ad3f","685":"57672787","893":"4a167461"}[chunkId] + ".chunk.css";
};